
import FreeShipping from "../component/freeshipping";
import ContactForm from "../component/ContactForm";
import Breadcrumb from "../component/Breadcrumb";
import PageTitle from "../component/pageTitle";

function ContactUs()
{

    return(
        <>
        <PageTitle title="تماس با ما"/>
        <Breadcrumb />
        <ContactForm />
        <FreeShipping />
        </>
    );


}
export default ContactUs;